module.exports = __webpack_public_path__ + "img/le-mot.364756f0.png";